<template>
  <div id="add-project" class="m-b-10">
    <!-- page header component -->
    <div class="bg-white shade py-2 px-3 mb-4" style="margin-top: 15px">
      <h3 style="font-size: 20px">
        <router-link to="/admin/dashboard">
          <i class="bi bi-arrow-left"></i>
        </router-link>
        Tambah Project Baru
      </h3>
    </div>
    <!-- step 2 component -->
    <div class="row">
      <div class="col-md-12">
        <alert-dynamic-component
          class="mb-4"
          type="warning"
          title="<i class='bi bi-info-circle'></i> Informasi!"
          subtitle="Default password: DIGIVLA --> user123*** - Selain DIGIVLA --> monitor123***"
        />
        <div class="bg-white p-l-20 p-t-10 p-r-20 p-b-20 shade">
          <alert-dynamic-component
            v-if="res == 'berhasil'"
            type="success"
            title="<i class='bi bi-check-circle'></i> Berhasil!"
            subtitle="Project berhasil ditambahkan."
          />
          <alert-dynamic-component
            v-if="res == 'gagal'"
            type="danger"
            title="<i class='bi bi-x-circle'></i> Gagal!"
            subtitle="Terjadi kesalahan pada saat menambahkan project baru."
          />
          <div class="form-add m-t-10">
            <div class="row">
              <div class="col-md-6">
                <h4>Step 2 - Daftar Pengguna</h4>
              </div>
              <div class="col-md-6">
                <button
                  class="btn btn-success btn-left-icon m-t-10 m-b-10 pull-right"
                  @click="addUser"
                >
                  <i class="bi bi-plus"></i> Tambah Pengguna
                </button>
              </div>
            </div>
            <div class="table-responsive">
              <table id="daftar-user" class="table table-bordered">
                <thead>
                  <tr>
                    <th width="10%" class="text-center">No</th>
                    <th>Nama</th>
                    <th>Username</th>
                    <th>Email</th>
                    <th>No Telepon</th>
                    <th>Role</th>
                    <th width="10%" class="text-center">Aksi</th>
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
          <div class="navigation-button" align="right">
            <router-link
              :to="'/admin/project/step1?ref=' + id_project"
              class="btn btn-danger m-r-10"
              >Sebelumnya</router-link
            >
            <button @click="nextStep" class="btn btn-success">
              Selanjutnya
            </button>
          </div>
        </div>
      </div>
    </div>
    <floating-loader-component
      key="loading_key"
      v-if="is_loading"
      :text="loading_text"
    />
    <modal-dynamic-component
      v-if="show_modal"
      :key="modal_key"
      :modal="data_modal"
      :data="data_modal.data"
    />
  </div>
</template>

<script>
import $ from "jquery";
import "bootstrap-daterangepicker/daterangepicker.js";
import alert_dynamic from "@/views/components/alert_dynamic.vue";
import floating_loader from "@/views/components/floating_loader.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_user from "@/views/components/super-admin/detail-project/modal_add_user.vue";

export default {
  name: "AddProjectStep2",
  title: "Tambah Project Baru | Online Media Monitoring",
  components: {
    "alert-dynamic-component": alert_dynamic,
    "floating-loader-component": floating_loader,
    "modal-dynamic-component": modal_dynamic,
  },
  data() {
    return {
      is_loading: false,
      loading_key: 0,
      loading_text: "Menyimpan Project...",
      table: null,
      res: null,
      id_project: this.$route.query.ref,
      users: null,
      role: [],
      modal_key: 10,
      data_modal: {
        title: "Tambah Pengguna",
        subtitle: "Silahkan masukan detail user",
        component: modal_add_user,
      },
      show_modal: false,
    };
  },
  methods: {
    getUser: function () {
      if (this.id_project) {
        let id_project = atob(this.id_project);
        let api = process.env.VUE_APP_API_URL + "users/" + id_project;
        this.$http.get(api).then((response) => {
          if (response.status == 200) {
            this.users = response.data;
            this.isError = false;
            let btn;
            this.table.clear();
            for (let index in this.users) {
              btn =
                '<center><button class="btn btn-sm btn-complete m-r-5 ch"><i class="bi bi-pencil-square"></i></button><button class="btn btn-sm btn-danger del"><i class="bi bi-trash"></i></button></center>';
              this.table.row
                .add([
                  `<center>${parseInt(index) + 1}</center>`,
                  this.users[index].nama,
                  this.users[index].username,
                  this.users[index].email,
                  this.users[index].phone,
                  this.role[this.users[index].role],
                  btn,
                ])
                .node().id = index;
              this.table.draw(false);
            }
          } else {
            this.users = {};
            this.isError = false;
          }
        });
      }
    },
    addUser: function () {
      this.data_modal = {
        title: "Tambah Pengguna",
        subtitle: "Silahkan masukan detail user",
        component: modal_add_user,
      };
      this.modal_key++;
      this.show_modal = true;
    },
    editUser: function (index) {
      let data = [];
      data["is_edit"] = true;
      data["user"] = this.users[index];
      this.data_modal = {
        title: "Edit Pengguna",
        subtitle: "Silahkan masukan detail user",
        component: modal_add_user,
        data: data,
      };
      this.modal_key++;
      this.show_modal = true;
    },
    nextStep: function () {
      this.is_loading = true;
      this.loading_text = "Mohon tunggu...";
      this.loading_key++;
      setTimeout(() => {
        this.$router.push({
          path: "/admin/project/detail",
          query: { ref: this.id_project },
        });
      }, 2000);
    },
  },
  created: function () {
    this.role[1] = "Super Admin";
    this.role[2] = "Admin";
    this.role[3] = "User";
    this.role[4] = "Viewer";
  },
  mounted: function () {
    this.table = $("#daftar-user").DataTable({
      paging: false,
      searching: false,
    });
    this.getUser();
    let self = this;
    $("#daftar-user").on("click", ".ch", function () {
      var tr = $(this).closest("tr");
      let id = $(tr).attr("id");
      self.editUser(id);
    });
  },
};
</script>

<style scoped>
select.form-control {
  -webkit-appearance: button;
  cursor: pointer;
}
</style>